"use strict"

/**
 * Opens bootstrap collapsable content if content has flash message.
 * This will only work when bootstrap collapse is build according to the bootstrap guidelines and when buttons `<button></button>` and not links `<a></a>` are used.
 * See guide: https://getbootstrap.com/docs/4.0/components/collapse/
 */
export default class FlashTab {

    /**
     * Constructor
     */
    constructor(selectorContainer = null) {
        this.dataFlashTabAttribute = 'data-click-flash-tab'; // container data attribute where bootstrap collapse resides.

        // bootstrap flash messages
        this.flashMessageClassNames = [
            'alert-primary',
            'alert-secondary',
            'alert-danger',
            'alert-success',
            'alert-warning',
            'alert-info',
            'alert-light',
            'alert-dark',
        ];

        // iterate through bootstrap collapsible containers where we need to check for flash messages
        document.querySelectorAll(selectorContainer ?? `[${this.dataFlashTabAttribute}]`).forEach(this.clickFlashContent.bind(this));
    }

    /**
     * Click flash content
     *
     * @param {Element} flashTab   A element with attribute this.dataFlashTabAttribute
     */
    clickFlashContent(flashTab) {
        // loop through bootstrap content elements
        for (const tabContent of flashTab.querySelectorAll('[data-parent].collapse')) {

            // check if content elements has a flash message class in them
            const hasFlashMessage = this.flashMessageClassNames.some((className, i) => {
                if (null !== tabContent.querySelector(`.${className}`)) return true;
            }) || false;

            if (true === hasFlashMessage) {

                // click on button to expand the associated content that has a flash message and is not expanded yet.
                const tabButton = flashTab.querySelector(`[data-target="#${tabContent.id}"][aria-expanded="false"]`);
                if (null !== tabButton) tabButton.click();

                break;
            }
        }
    }
}
